module.exports = __webpack_public_path__ + "img/money.54e37a91.svg";